import * as Yup from 'yup';
import { validatePostcode } from '../utility/addAddressHelper';

const addAddressSchema = Yup.object({
  StreetName: Yup.string()
    .required('Street Name is required')
    .min(2, 'Street Name must be more than 1 character'),

  ptsCityID: Yup.number().nullable().required('City is required'),

  State: Yup.string().required('State is required'),

  Postal: Yup.string()
    .nullable()
    .test('postal-format', 'Must consist of 5 or 9 digits', (value) => {
      if (!value) return true;
      return validatePostcode(value);
    }),
}).shape(
  {
    UnitType: Yup.string()
      .nullable()
      .when('UnitIdentifier', {
        is: (value) => Boolean(value),
        then: (schema) => schema.required('Unit Type is missing'),
      }),

    UnitIdentifier: Yup.string()
      .nullable()
      .when('UnitType', {
        is: (value) => Boolean(value),
        then: (schema) => schema.required('Unit Identifier is missing'),
      }),
  },
  [['UnitType', 'UnitIdentifier']]
);

export default addAddressSchema;
